import React, { useEffect, useState, useContext } from "react";
import Sidebar from "../sidebar";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Typography,
  TextField,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import "./Cybersecurity.css";
import { api, get, post, put } from "../../../utils/api";
import { textError, numberError } from "../../../utils/validationMessage";
import ActionButtons from "../InitialKickoff/MaterialTopics/ActionButtons";
import { ProgressContext } from "../ContextAPI";
import { useUser } from "../../../context/AuthContext";
import SkipQuestionare from "../../Common/SkipQuestionare";
import InitialQuestionareSidebar from "../../../Layout/InitialQuestionareSidebar";
import { getQuestionareSubmitted } from "../../../utils/storage";

const Cybersecurity = () => {
  const navigate = useNavigate();
  const { setUpdate } = useContext(ProgressContext);
  const { setUser, setModule } = useUser();
  const companyDetails = getQuestionareSubmitted();

  const [value, setValue] = useState([
    {
      high: "Number of Breaches",
      medium: "Number of Breaches",
      low: "Number of Breaches",
    },
  ]);
  const [isExist, setisExist] = useState(false);
  const [formData, setFromData] = useState({
    cybersecurityIncidents: {
      high: "",
      medium: "",
      low: "",
      total: "",
    },
    dataPrivacyBreaches: {
      high: "",
      medium: "",
      low: "",
      total: "",
    },
    implementationCybersecurityMeasure: {
      radio: "yes",
      Scope: "",
    },
  });
  const [errors, setErrors] = useState({});
  const handleChangeCybersecurity = (e) => {
    console.log(e.target.name);
    const { name, value } = e.target;
    setFromData({
      ...formData,
      implementationCybersecurityMeasure: {
        ...formData.implementationCybersecurityMeasure,
        [name]: value,
      },
    });

    setErrors((prevErrors) => ({
      ...prevErrors,
      implementationCybersecurityMeasureScope: "", // Clear the error for total field
    }));
  };
  const handleChangeDataPrivacy = (e) => {
    const { name, value } = e.target;
    // const numericValue = parseInt(value, 10) || 0;
    // const numericValue = value === "" ? "" : parseInt(value, 10);
    const numericValue =
      value === "" || isNaN(Number(value))
        ? ""
        : Math.max(0, parseInt(value, 10));
    // Calculate the new total
    const newCybersecurityIncidents = {
      ...formData.dataPrivacyBreaches,
      [name]: numericValue,
    };

    newCybersecurityIncidents.total =
      newCybersecurityIncidents.high +
      newCybersecurityIncidents.medium +
      newCybersecurityIncidents.low;

    setFromData({
      ...formData,
      dataPrivacyBreaches: newCybersecurityIncidents,
    });
    setErrors((prevErrors) => ({
      ...prevErrors,
      dataPrivacyBreachesTotal: "", // Clear the error for total field
    }));
  };
  const handleImplementation = (e) => {
    console.log(e.target.name, e.target.value);
    const { name, value } = e.target;
    // setFromData({
    //   ...formData,
    //   cybersecurityIncidents:{
    //     ...formData.cybersecurityIncidents,
    //    [name]:value
    //   }
    // })
    // const numericValue = parseInt(value, 10) || 0;
    const numericValue =
      value === "" || isNaN(Number(value))
        ? ""
        : Math.max(0, parseInt(value, 10));
    // Calculate the new total
    const newCybersecurityIncidents = {
      ...formData.cybersecurityIncidents,
      [name]: numericValue,
    };

    newCybersecurityIncidents.total =
      newCybersecurityIncidents.high +
      newCybersecurityIncidents.medium +
      newCybersecurityIncidents.low;

    setFromData({
      ...formData,
      cybersecurityIncidents: newCybersecurityIncidents,
    });
    setErrors((prevErrors) => ({
      ...prevErrors,
      cybersecurityIncidentsTotal: "", // Clear the error for total field
    }));
  };
  console.log("data", formData);
  const validateForm = () => {
    const newErrors = {};

    const {
      cybersecurityIncidents,
      dataPrivacyBreaches,
      implementationCybersecurityMeasure,
    } = formData;

    // const validateCybersecurityIncidents = () => {

    //   // Validate high, medium, low if they exist
    //   ["high", "medium", "low"].forEach((severity) => {
    //     if (
    //       isNaN(cybersecurityIncidents[severity]) ||
    //       cybersecurityIncidents[severity] < 0 ||
    //       cybersecurityIncidents[severity] === ""
    //     ) {
    //       newErrors[
    //         `cybersecurityIncidents${
    //           severity.charAt(0).toUpperCase() + severity.slice(1)
    //         }`
    //       ] = numberError;
    //     }
    //   });
    // };
    // const validateDataPrivacyBreaches = () => {

    //   // Validate high, medium, low if they exist
    //   ["high", "medium", "low"].forEach((severity) => {
    //     if (
    //       isNaN(dataPrivacyBreaches[severity]) ||
    //       dataPrivacyBreaches[severity] < 0 ||
    //       dataPrivacyBreaches[severity] === ""
    //     ) {
    //       newErrors[
    //         `dataPrivacyBreaches${
    //           severity.charAt(0).toUpperCase() + severity.slice(1)
    //         }`
    //       ] = numberError;
    //     }
    //   });
    // };

    // Validate `implementationCybersecurityMeasure`
    if (
      (!implementationCybersecurityMeasure.Scope &&
        implementationCybersecurityMeasure.radio === "yes") ||
      (implementationCybersecurityMeasure.Scope.trim() === "" &&
        implementationCybersecurityMeasure.radio === "yes")
    ) {
      newErrors.implementationCybersecurityMeasureScope = textError;
    }
    // validateCybersecurityIncidents();
    // validateDataPrivacyBreaches();
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  useEffect(() => {
    setUpdate("GOVERNANCE");
    const fetchData = async () => {
      try {
        const url = `/governance/cybersecurity-dataprivacy`;
        const data = await get(url);

        setFromData({
          cybersecurityIncidents: {
            high: data?.data?.cybersecurityIncidents.high,
            medium: data?.data?.cybersecurityIncidents.medium,
            low: data?.data?.cybersecurityIncidents.low,
            total: data?.data?.cybersecurityIncidents.total,
          },
          dataPrivacyBreaches: {
            high: data?.data?.dataPrivacyBreaches.high,
            medium: data?.data?.dataPrivacyBreaches.medium,
            low: data?.data?.dataPrivacyBreaches.low,
            total: data?.data?.dataPrivacyBreaches.total,
          },
          implementationCybersecurityMeasure: {
            radio: data?.data?.implementationCybersecurityMeasure.radio
              ? "yes"
              : "no",
            Scope: data?.data?.implementationCybersecurityMeasure.Scope,
          },
        });
        setisExist(true);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  console.log("isExist", isExist);

  const Save = async () => {
    if (!validateForm()) {
      return;
    }
    const url = `${api}/governance/cybersecurity-dataprivacy`;
    const {
      implementationCybersecurityMeasure,
      cybersecurityIncidents,
      dataPrivacyBreaches,
    } = formData;

    const isNonEmptyString = (val) =>
      typeof val === "string" && val.trim().length > 0;
    const isValidNumber = (val) => typeof val === "number" && val >= 0;

    // Calculate cybersecurity key
    const cybersecurity =
      isNonEmptyString(implementationCybersecurityMeasure?.radio) &&
      (isNonEmptyString(implementationCybersecurityMeasure?.Scope) ||
        isValidNumber(cybersecurityIncidents?.total) ||
        isValidNumber(dataPrivacyBreaches?.total));

    const dataToSend = {
      ...formData,
      cybersecurity,
    };

    try {
      const response = isExist
        ? await put(`${url}`, dataToSend)
        : await post(url, dataToSend);
      // localStorage.setItem("user", JSON.stringify(response?.data?.user));
      setUser(response?.data?.user);
      navigate("/preview");
    } catch (error) {
      console.error("Save Error:", error);
      alert(error.message || "An error occurred while saving the data.");
    }
  };

  const Back = () => {
    navigate("/governance/stakeholder");
  };

  return (
    <Box sx={{ display: "flex", backgroundColor: "#EDEDED", height: "100vh" }}>
      <Box
        sx={{
          width: "25vw",
          // overflowY: "auto",
        }}
      >
        <InitialQuestionareSidebar />
      </Box>
      <Box
        width="100%"
        sx={{
          p: 2,
          mt: 3,
          width: "75vw",
          height: "100vh", // Full viewport height
          overflowY: "auto", // Allow vertical scrolling if content exceeds viewport
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "flex-start", // Adjust to start at the top of the box
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "80%",
            marginBottom: "1rem",
          }}
        >
          <Typography
            variant="h5"
            sx={{
              width: "60%",
              fontWeight: "bold",
              zIndex: 1,
              padding: "10px 0px",
              borderRadius: "4px",
              alignSelf: "flex-start",
            }}
          >
            GOVERNANCE: CYBERSECURITY & DATA PRIVACY
          </Typography>
          <SkipQuestionare />
        </div>

        <Box sx={{ width: "80%" }}>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: "bold", mb: 2, mt: 2 }}
            className="heading"
          >
            Cybersecurity Incidents
          </Typography>
          <Box sx={{ display: "flex", width: "100%", gap: "50px", mb: 3 }}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 2,
                textTransform: "uppercase",
              }}
            >
              {value.map((severity, index) => (
                <>
                  {Object.keys(severity).map((item, i) => {
                    //  {console.log("item",item,i)}
                    return (
                      <TextField
                        key={i}
                        variant="outlined"
                        value={item}
                        sx={{
                          textAlign: "center",
                          fontWeight: "bold",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          width: "100%",
                          border: "1px solid #958f8f",
                          borderRadius: "5px",
                          cursor: "default",
                          pointerEvents: "none", // Prevents focus and interactions
                          "& .MuiOutlinedInput-root": {
                            height: "48px",
                            padding: "0 10px",
                            pointerEvents: "none", // Prevents click and focus
                          },
                          "& .MuiOutlinedInput-input": {
                            cursor: "default", // Ensures cursor doesn't change inside input
                          },
                          "& .MuiOutlinedInput-notchedOutline": {
                            border: "none", // Removes focus border
                          },
                        }}
                      />
                    );
                  })}
                </>
              ))}
            </Box>

            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                flexWrap: "wrap",
                gap: 2.1,
                width: "100%",
              }}
            >
              {value.map((placeholder, index) => (
                //  console.log(Object.values(placeholder),Object(placeholder))
                <>
                  {Object.keys(placeholder).map((i) => (
                    <>
                      <TextField
                        key={i}
                        variant="outlined"
                        placeholder={placeholder[i]}
                        name={i}
                        value={
                          formData.cybersecurityIncidents[i] !== undefined
                            ? formData.cybersecurityIncidents[i]
                            : ""
                        }
                        // className="inputfieldCustomer"
                        onChange={(e) => {
                          handleImplementation(e);
                          setErrors({
                            ...errors,
                            [`cybersecurityIncidents${
                              i.charAt(0).toUpperCase() + i.slice(1)
                            }`]: "",
                          });
                        }}
                        aria-label={placeholder}
                        fullWidth
                        InputProps={{
                          style: {
                            borderColor: errors[
                              `cybersecurityIncidents${
                                i.charAt(0).toUpperCase() + i.slice(1)
                              }`
                            ]
                              ? "#D34040"
                              : undefined,
                          },
                        }}
                        sx={{
                          marginRight: "5px",
                          marginTop: "0px",
                          width: "100%",
                          "& .MuiOutlinedInput-root": {
                            height: "49px",
                          },
                        }}
                        error={
                          !!errors[
                            `cybersecurityIncidents${
                              i.charAt(0).toUpperCase() + i.slice(1)
                            }`
                          ]
                        } // Check error state for total
                        InputLabelProps={{
                          style: {
                            color: errors[
                              `cybersecurityIncidents${
                                i.charAt(0).toUpperCase() + i.slice(1)
                              }`
                            ]
                              ? "#D34040"
                              : undefined,
                          },
                        }}
                      />
                      {errors[
                        `cybersecurityIncidents${
                          i.charAt(0).toUpperCase() + i.slice(1)
                        }`
                      ] && (
                        <Typography variant="body2" color="#D34040">
                          {
                            errors[
                              `cybersecurityIncidents${
                                i.charAt(0).toUpperCase() + i.slice(1)
                              }`
                            ]
                          }
                        </Typography>
                      )}
                    </>
                  ))}

                  <TextField
                    key={index}
                    variant="outlined"
                    placeholder="Total Breaches"
                    value={
                      formData.cybersecurityIncidents.total === ""
                        ? ""
                        : formData.cybersecurityIncidents.total
                    }
                    // className="inputfieldCustomer"
                    // onChange={handleChangeValue}
                    aria-label={placeholder}
                    fullWidth
                    InputProps={{
                      style: {
                        borderColor: errors.cybersecurityIncidentsTotal
                          ? "#D34040"
                          : undefined,
                      },
                    }}
                    sx={{
                      width: "100%",
                      "& .MuiOutlinedInput-root": {
                        height: "49px",
                      },
                    }}
                    error={!!errors.cybersecurityIncidentsTotal} // Show error styling if there's an error
                    InputLabelProps={{
                      style: {
                        color: errors.cybersecurityIncidentsTotal
                          ? "#D34040"
                          : undefined,
                      },
                    }}
                  />
                  {errors.cybersecurityIncidentsTotal && (
                    <Typography variant="body2" color="#D34040">
                      {errors.cybersecurityIncidentsTotal}
                    </Typography>
                  )}
                </>
              ))}
            </Box>
          </Box>
        </Box>

        <Box sx={{ width: "80%" }}>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: "bold", mb: 2 }}
            className="heading"
          >
            Data Privacy Breaches
          </Typography>
          <Box sx={{ display: "flex", width: "100%", gap: "50px", mb: 3 }}>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
              {value.map((severity, index) => (
                // console.log("inside map",severity,index,
                <>
                  {Object.keys(severity).map((item, i) => {
                    //  {console.log("item",item,i)}
                    return (
                      <>
                        <TextField
                          key={i}
                          variant="outlined"
                          value={item}
                          // sx={{
                          //   textAlign: "center",
                          //   fontWeight: "bold",
                          //   display: "flex",
                          //   alignItems: "center",
                          //   justifyContent: "center",
                          //   width: "100%",
                          //   border: "1px solid #958f8f",
                          //   borderRadius: "5px",
                          //   "& .MuiOutlinedInput-root": {
                          //     height: "48px",
                          //     padding: "0 10px",
                          //   },
                          // }}
                          sx={{
                            textAlign: "center",
                            fontWeight: "bold",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: "100%",
                            border: "1px solid #958f8f",
                            borderRadius: "5px",
                            cursor: "default",
                            pointerEvents: "none", // Prevents focus and interactions
                            "& .MuiOutlinedInput-root": {
                              height: "48px",
                              padding: "0 10px",
                              pointerEvents: "none", // Prevents click and focus
                            },
                            "& .MuiOutlinedInput-input": {
                              cursor: "default", // Ensures cursor doesn't change inside input
                            },
                            "& .MuiOutlinedInput-notchedOutline": {
                              border: "none", // Removes focus border
                            },
                          }}
                        />
                      </>
                    );
                  })}
                </>
              ))}
            </Box>

            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                flexWrap: "wrap",
                gap: 2.1,
                width: "100%",
              }}
            >
              {value.map((placeholder, index) => (
                //  console.log(Object.values(placeholder),Object(placeholder))
                <>
                  {Object.keys(placeholder).map((i) => (
                    <>
                      <TextField
                        key={i}
                        variant="outlined"
                        placeholder={placeholder[i]}
                        name={i}
                        value={
                          formData.dataPrivacyBreaches[i] !== undefined
                            ? formData.dataPrivacyBreaches[i]
                            : ""
                        }
                        sx={{
                          marginRight: "5px",
                          marginTop: "0px",
                          "& .MuiOutlinedInput-root": {
                            height: "49px",
                          },
                        }}
                        // value={formData.dataPrivacyBreaches[i]===0?"":formData.dataPrivacyBreaches[i]}
                        // className="inputfieldCustomer"
                        onChange={(e) => {
                          handleChangeDataPrivacy(e);
                          setErrors((prevErrors) => ({
                            ...prevErrors,
                            [`dataPrivacyBreaches${
                              i?.charAt(0).toUpperCase() + i?.slice(1)
                            }`]: "",
                          }));
                        }}
                        aria-label={placeholder}
                        fullWidth
                        InputProps={{
                          style: {
                            borderColor: errors[
                              `dataPrivacyBreaches${
                                i?.charAt(0).toUpperCase() + i?.slice(1)
                              }`
                            ]
                              ? "#D34040"
                              : undefined,
                          },
                        }}
                        error={
                          !!errors[
                            `dataPrivacyBreaches${
                              i?.charAt(0).toUpperCase() + i?.slice(1)
                            }`
                          ]
                        } // Check error state for total
                        InputLabelProps={{
                          style: {
                            color: errors[
                              `dataPrivacyBreaches${
                                i?.charAt(0).toUpperCase() + i?.slice(1)
                              }`
                            ]
                              ? "#D34040"
                              : undefined,
                          },
                        }}
                      />
                      {errors[
                        `dataPrivacyBreaches${
                          i?.charAt(0).toUpperCase() + i?.slice(1)
                        }`
                      ] && (
                        <Typography variant="body2" color="#D34040">
                          {
                            errors[
                              `dataPrivacyBreaches${
                                i?.charAt(0).toUpperCase() + i?.slice(1)
                              }`
                            ]
                          }
                        </Typography>
                      )}
                    </>
                  ))}

                  <TextField
                    key={index}
                    variant="outlined"
                    placeholder="Total Breaches"
                    value={
                      formData.dataPrivacyBreaches.total === ""
                        ? ""
                        : formData.dataPrivacyBreaches.total
                    }
                    // className="inputfieldCustomer"
                    // onChange={handleChangeValue}
                    aria-label={placeholder}
                    fullWidth
                    InputProps={{
                      style: {
                        borderColor: errors.dataPrivacyBreachesTotal
                          ? "#D34040"
                          : undefined,
                      },
                    }}
                    sx={{
                      width: "100%",
                      "& .MuiOutlinedInput-root": {
                        height: "49px",
                      },
                    }}
                    error={!!errors.dataPrivacyBreachesTotal} // Show error styling if there's an error
                    InputLabelProps={{
                      style: {
                        color: errors.dataPrivacyBreachesTotal
                          ? "#D34040"
                          : undefined,
                      },
                    }}
                  />
                  {errors.dataPrivacyBreachesTotal && (
                    <Typography variant="body2" color="#D34040">
                      {errors.dataPrivacyBreachesTotal}
                    </Typography>
                  )}
                </>
              ))}
            </Box>
          </Box>
        </Box>

        <Box sx={{ width: "80%" }}>
          <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 2 }}>
            Implementation of Cybersecurity Measure
          </Typography>
          <RadioGroup
            row
            name="radio"
            value={formData.implementationCybersecurityMeasure.radio}
            onChange={handleChangeCybersecurity}
            sx={{ mb: 2 }}
          >
            <FormControlLabel value="yes" control={<Radio />} label="Yes" />
            <FormControlLabel value="no" control={<Radio />} label="No" />
          </RadioGroup>
          {formData.implementationCybersecurityMeasure.radio === "yes" ? (
            <Box>
              <TextField
                variant="outlined"
                placeholder="Scope..."
                // className="brief"
                name="Scope"
                value={formData.implementationCybersecurityMeasure.Scope}
                onChange={(e) => {
                  handleChangeCybersecurity(e);
                  setErrors({
                    ...errors,
                    implementationCybersecurityMeasureScope: "",
                  });
                }}
                multiline
                rows={3}
                // sx={{ width: '100%' }}
                InputProps={{
                  style: {
                    borderColor: errors.implementationCybersecurityMeasureScope
                      ? "#D34040"
                      : undefined,
                  },
                }}
                sx={{ marginRight: "5px", width: "100%" }}
                error={!!errors.implementationCybersecurityMeasureScope} // Show error styling if there's an error
                InputLabelProps={{
                  style: {
                    color: errors.implementationCybersecurityMeasureScope
                      ? "#D34040"
                      : undefined,
                  },
                }}
              />
              {errors.implementationCybersecurityMeasureScope && (
                <Typography variant="body2" color="#D34040">
                  {errors.implementationCybersecurityMeasureScope}
                </Typography>
              )}
            </Box>
          ) : (
            ""
          )}
          <ActionButtons
            Back={Back}
            Move={Save}
            disable={companyDetails?.questionareSubmitted}
          />
        </Box>

        {/* <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 4, width: '80%' }}>
          <Button
            variant="outlined"
            sx={{color:"#0a3f73",borderColor:"#0a3f73",textTransform:"none"}}
            onClick={Back}
            startIcon={<ArrowBackIcon />}
          >
            Back
          </Button>
          <Button
            variant="contained"
            sx={{backgroundColor:"#0a3f73",textTransform:"none"}}
            onClick={Save}
            endIcon={<ArrowForwardIcon />}
          >
            Save and continue
          </Button>
        </Box> */}
      </Box>
    </Box>
  );
};

export default Cybersecurity;
